'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Price(_ref) {
  var i18n = _ref.i18n,
      item = _ref.item,
      currency = _ref.currency;

  var price = new Intl.NumberFormat(i18n.lang.replace('_', '-')).format(Number(item.price));
  return _react2.default.createElement(
    'div',
    { className: 'plan-price' },

    // XXX: when the item has a 'lead' value, it's a dateless search,
    //      this is a workaround for the result change timing issue
    item.lead ? i18n.hotelSearch.from.split(/({.*?})/).map(function (text, index) {
      switch (text) {
        case '{currency}':
          return _react2.default.createElement(
            'span',
            { key: index, className: 'price-currency' },
            currency.symbol
          );
        case '{price}':
          return _react2.default.createElement(
            'span',
            { key: index, className: 'price-bold' },
            price
          );
        default:
          return text.trim() ? _react2.default.createElement(
            'span',
            { key: index, className: 'price-info' },
            text.trim()
          ) : null;
      }
    }) : i18n.hotelSearch.total.split(/({.*?})/).map(function (text, index) {
      switch (text) {
        case '{currency}':
          return _react2.default.createElement(
            'span',
            { key: index, className: 'price-currency' },
            currency.symbol
          );
        case '{price}':
          return _react2.default.createElement(
            'span',
            { key: index, className: 'price-bold' },
            price
          );
        default:
          return text.trim() ? _react2.default.createElement(
            'span',
            { key: index, className: 'price-info' },
            text.trim()
          ) : null;
      }
    })
  );
} // Price

Price.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  item: _react.PropTypes.object.isRequired,
  currency: _react.PropTypes.object.isRequired
};

exports.default = Price;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Price.js
// module id = 579
// module chunks = 0